if (typeof NutritionalInfo !== 'function') {
  class NutritionalInfo extends HTMLElement {
    constructor() {
      super();

      const rawContent = this.innerHTML;
      const titleLabelLeft = this.dataset.titleLabelLeft || '';
      const titleLabelRight = this.dataset.titleLabelRight || '';

      const sections = this.buildSections(rawContent);

      this.innerHTML = this.renderSections(
        sections,
        titleLabelLeft,
        titleLabelRight
      );

      this.initCollapsibles();
    }

    buildSections(rawContent) {
      const cleanedContent = rawContent
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>|<\/div>|<\/li>/gi, '\n')
        .replace(/<p[^>]*>|<div[^>]*>|<li[^>]*>/gi, '')
        .replace(/<\/?strong[^>]*>/gi, '')
        .replace(/<\/?span[^>]*>/gi, '')
        .replace(/&nbsp;/gi, ' ');

      const lines = cleanedContent
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => line.length > 0);

      const sections = [];
      let currentSection = null;

      lines.forEach((line) => {
        const isDataRow = line.includes(',');

        if (!isDataRow) {
          currentSection = {
            title: line,
            rows: []
          };

          sections.push(currentSection);
          return;
        }

        if (!currentSection) {
          currentSection = {
            title: '',
            rows: []
          };

          sections.push(currentSection);
        }

        currentSection.rows.push(line);
      });

      return sections;
    }

    renderSections(sections, titleLabelLeft, titleLabelRight) {
      let contentDOM = '';

      sections.forEach((section, sectionIndex) => {
        const sectionId = `nutrition-section-${sectionIndex}-${Math.random()
          .toString(36)
          .slice(2)}`;

        if (section.title) {
          contentDOM += `
            <div class="nutrition-collapsible">
              <button
                type="button"
                class="nutrition-collapsible__button"
                aria-expanded="false"
                aria-controls="${sectionId}"
              >
                <span>${section.title}</span>
                <span class="nutrition-collapsible__icon" aria-hidden="true">+</span>
              </button>

              <div
                id="${sectionId}"
                class="nutrition-collapsible__content"
                aria-hidden="true"
              >
                <div class="nutrition-collapsible__content-inner">
                  ${this.renderTable(section.rows, titleLabelLeft, titleLabelRight)}
                </div>
              </div>
            </div>
          `;
        } else {
          contentDOM += this.renderTable(
            section.rows,
            titleLabelLeft,
            titleLabelRight
          );
        }
      });

      return contentDOM;
    }

    renderTable(rows, titleLabelLeft, titleLabelRight) {
      if (!rows.length) return '';

      let tableDOM = `<div class="table">`;

      if (titleLabelLeft !== '' || titleLabelRight !== '') {
        tableDOM += `
          <span class="table-line table-line--heading">
            <span>${titleLabelLeft || '&nbsp;'}</span>
            <span>${titleLabelRight || '&nbsp;'}</span>
          </span>
        `;
      }

      rows.forEach((row) => {
        const rowParts = this.splitNutritionRow(row);

        const leftValue = rowParts[0]
          ? rowParts[0].replace('-', '').trim()
          : '&nbsp;';

        const rightValue = rowParts[1]
          ? rowParts[1].trim()
          : '&nbsp;';

        tableDOM += `
          <span class="table-line ${row.includes('-') ? 'table-line--indent' : ''}">
            <span>${leftValue}</span>
            <span>${rightValue}</span>
          </span>
        `;
      });

      tableDOM += `</div>`;

      return tableDOM;
    }

    splitNutritionRow(row) {
      const firstCommaIndex = row.indexOf(',');

      if (firstCommaIndex === -1) {
        return [row.trim(), ''];
      }

      return [
        row.slice(0, firstCommaIndex).trim(),
        row.slice(firstCommaIndex + 1).trim()
      ];
    }

    initCollapsibles() {
      const buttons = this.querySelectorAll('.nutrition-collapsible__button');

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const contentId = button.getAttribute('aria-controls');
          const content = this.querySelector(`#${contentId}`);
          const icon = button.querySelector('.nutrition-collapsible__icon');
          const isExpanded = button.getAttribute('aria-expanded') === 'true';

          /**
           * Close all other sections first.
           */
          buttons.forEach((otherButton) => {
            if (otherButton === button) return;

            const otherContentId = otherButton.getAttribute('aria-controls');
            const otherContent = this.querySelector(`#${otherContentId}`);
            const otherIcon = otherButton.querySelector('.nutrition-collapsible__icon');

            otherButton.setAttribute('aria-expanded', 'false');

            if (otherContent) {
              otherContent.classList.remove('is-open');
              otherContent.setAttribute('aria-hidden', 'true');
              otherContent.style.maxHeight = null;
            }

            if (otherIcon) {
              otherIcon.textContent = '+';
            }
          });

          /**
           * Toggle the clicked section.
           */
          if (isExpanded) {
            button.setAttribute('aria-expanded', 'false');

            if (content) {
              content.classList.remove('is-open');
              content.setAttribute('aria-hidden', 'true');
              content.style.maxHeight = null;
            }

            if (icon) {
              icon.textContent = '+';
            }
          } else {
            button.setAttribute('aria-expanded', 'true');

            if (content) {
              content.classList.add('is-open');
              content.setAttribute('aria-hidden', 'false');
              content.style.maxHeight = `${content.scrollHeight}px`;
            }

            if (icon) {
              icon.textContent = '−';
            }
          }
        });
      });

      /**
       * Keep opened sections at the correct height if the screen resizes.
       */
      window.addEventListener('resize', () => {
        const openContents = this.querySelectorAll(
          '.nutrition-collapsible__content.is-open'
        );

        openContents.forEach((content) => {
          content.style.maxHeight = `${content.scrollHeight}px`;
        });
      });
    }
  }

  if (typeof customElements.get('nutritional-info') === 'undefined') {
    customElements.define('nutritional-info', NutritionalInfo);
  }
}